/**
 * Centralised API base URL.
 * Change this one value to switch between local dev and production.
 */
export const API_BASE_URL = "https://vibechat-177v.onrender.com";
export const SOCKET_ENDPOINT = "https://vibechat-177v.onrender.com";
